module.exports = __webpack_public_path__ + "static/media/galerija_2021 (28)-min.a25e321f.jpg";